// Components
import Layout from "../../components/Layout/Layout";
import { meta } from "../../globals";

const Services = () => {
  return (
    <Layout
      meta={{
        title: meta.homeTitle,
        keywords: meta.homeKeywords,
        description: meta.homeDescription,
      }}
      header
      footer
    >
      <h1>I am the services</h1>
    </Layout>
  );
};

export default Services;
